export const buildCookieServiceOptions = (secure: boolean, expires?: number | Date) => {
  let options = {
    secure: secure,
    expires: expires ? expires : 60
  };
  return options;
};
